export function validate(values) {
    var _a, _b, _c, _d, _e, _f, _g;
    const errors = { hook: {} };
    if (!values) {
        return errors;
    }
    if (!((_b = (_a = values === null || values === void 0 ? void 0 : values.hook) === null || _a === void 0 ? void 0 : _a.title) === null || _b === void 0 ? void 0 : _b.trim())) {
        errors.hook.title = 'Please add a title';
    }
    if (!((_d = (_c = values === null || values === void 0 ? void 0 : values.hook) === null || _c === void 0 ? void 0 : _c.apikey) === null || _d === void 0 ? void 0 : _d.trim())) {
        errors.hook.apikey = 'Please add an API key';
    }
    if (!((_f = (_e = values === null || values === void 0 ? void 0 : values.hook) === null || _e === void 0 ? void 0 : _e.magentoSubdomain) === null || _f === void 0 ? void 0 : _f.trim())) {
        errors.hook.magentoSubdomain = 'Please add a subdomain';
    }
    if (!((_g = values === null || values === void 0 ? void 0 : values.template) === null || _g === void 0 ? void 0 : _g.trim())) {
        errors.template = 'Please add some template content';
    }
    return errors;
}
export const apiKeyHelpText = `Please insert the API key corresponding to the Magento account that you want Dixa to receive data from.`;
export const subdomainHelpText = `Please insert your Magento subdomain name here.`;
